export default __webpack_public_path__ + "static/media/BG.53f78854.png";